/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Go back",
      "<h3 class=”header-3”>Accessibility Status</h3> <p>The European Accessibility Act requires that we design our ecommerce services (including identification and payment methods) with accessibility in mind, so that they are perceivable, operable, understandable and robust. In addition to this, we aim to design our websites and mobile applications in accordance with the <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">W3C’s Web Content Accessibility Guidelines 2.1, Level AA</a>. To achieve these goals, we have: </p> <ul> <li>Partnered with accessibility consultancies like Level Access to understand how we can make our services more accessible.</li> <li>Evaluated our digital experiences against global accessibility standards.</li> <li>Learned from a diverse team of accessibility experts, including users with disabilities and additional accessibility needs.</li> </ul>",
      "<h3 class=”header-3”>Feedback and Contact</h3> <p>While we aim to ensure accessibility for all users, some limitations may exist. We welcome feedback to help us improve, so if you encounter accessibility barriers or require information in an alternative format, please contact us at accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Future Improvements</h3> <p>Our accessibility work is ongoing. We will continue to:</p> <ul> <li>Monitor and review accessibility across all digital platforms.</li> <li>Fix known issues and prevent future barriers by designing with accessibility in mind.</li> <li>Expand internal training and awareness to improve inclusive design practices.</li> </ul>",
      "<h3 class=”header-3”>Last updated: November 2025</h3>",
      "<h3 class=”header-3”>Measures Taken</h3> <p>To achieve accessibility on our services, we have:</p> <ul> <li>Partnered with Level Access to conduct comprehensive accessibility evaluations and guidance.</li> <li>Embedded accessibility tools into our platforms, including assistive technologies such as keyboard alternatives, speech enablement, and touch-free navigation.</li> <li>Conducted user testing with people with disabilities to gather real feedback and inform improvements.</li> <li>Integrated accessibility considerations into our product development lifecycle and quality assurance processes.</li> <li>Established a digital accessibility programme across the organisation.</li> <li>Implemented an <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">assistive customer experience platform</a>. This is free and available to people who have trouble typing, gesturing, moving a mouse, or reading. It incorporates tools such as mouse and keyboard replacements, voice recognition, speech enablement, hands- free/touch-free navigation, and more.</li> </ul>",
      "<h3 class=”header-3”>Our policy</h3> <p>At Bumble, equity is at the heart of our values. It’s much more than just a buzzword to us—we're striving to make Bumble experiences accessible, fair and equitable.</p> <p>This accessibility statement has been prepared to inform our users about the accessibility of our service, including its alignment with relevant legal and technical standards. This accessibility statement applies to the elements of our services [RS2] covered by the European Accessibility Act, in particular our ecommerce services, which allow users to upgrade to a range of enhanced, premium Bumble features. These services can be accessed through the Bumble app.</p>",
      "EAA Accessibility Statement",
      "Download on the App Store",
      "Get it on Google Play",
      "Carousel",
      "Slide {{number}}",
      "Next slide",
      "Previous slide",
      "Slide",
      "Slide {{number}} of {{total}}",
      "Do not sell or share my personal information",
      "Do not sell or share my personal information",
      "Send Compliments on Bumble to show you like their profile, and get their attention before you match. Try it now",
      "Compliments | How to Send a Compliment | Bumble",
      "A personalized page that highlights your most compatible people, refreshed daily.",
      "Discover | Find Compatible People | Bumble",
      "Date at your own pace and stay in control of who sees your Bumble profile with Incognito Mode. Learn more about using Incognito Mode on Bumble in our guide",
      "Incognito Mode | Hide Your Profile | Bumble",
      "After meeting at a Bumble IRL event, build on the chemistry by continuing the conversation in the app.",
      "Instant Match | Keep The Conversation Going On The App | Bumble",
      "Need a little break or some time for yourself? Find out how to pause your Bumble account with Bumble’s Snooze Mode. It lets you date on your terms",
      "Snooze Mode | Pause Your Account | Bumble",
      "Just seen someone you really like on Bumble? Use a SuperSwipe to show them you’re serious. Tap the star on their profile to get started, or see more details here",
      "Bumble SuperSwipe | What’s a SuperSwipe? | Bumble",
      "Traveling for work or play? Travel Mode on Bumble can help you make fun new connections in a new place and date wherever you go. Discover Travel Mode here now",
      "Bumble’s Travel Mode | Date Wherever You Go | Bumble",
      "Want to know if the connection you’re feeling over messages will mean IRL chemistry? Try a video chat or voice call on Bumble now and get a good vibe check",
      "Video Chat | Make a Call | Bumble",
      "Bumble Date",
      "Our apps",
      "About",
      "Careers",
      "Contact us",
      "Investors",
      "The Shop",
      "Company",
      "Download the app",
      "Accessibility at Bumble",
      "Guidelines",
      "Manage cookies",
      "Modern Slavery act",
      "Notice at collection",
      "Privacy policy",
      "Terms and conditions",
      "Legal",
      "Washington Consumer Health Privacy Policy",
      "Scan the QR code to get the Bumble app",
      "Sign in",
      "Terminate contracts here",
      "Download now",
      "Just scan the QR code to get started.",
      "Find your next date",
      "Get the app",
      "Bumble homepage",
      "Close menu",
      "Open menu",
      "Coming Soon: Bumble Love Stories",
      "Choose your language",
      "Language selection",
      "Footer",
      "Accessibility at Bumble",
      "Apple and the Apple logo are trademarks of Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Careers",
      "Events",
      "Google Play is a trademark of Google LLC.",
      "Guidelines",
      "Investors",
      "Manage Cookies",
      "Manage Cookies",
      "Modern Slavery Act Statement",
      "Notice At Collection",
      "Privacy Policy",
      "Seasonal Dating Guides",
      "Terms & Conditions",
      "The app",
      "Washington Consumer Health Data Privacy Policy",
      "About",
      "Ambassadors",
      "Make new friends and find your community",
      "Network professionally and make career moves",
      "Find a relationship, something casual, or anything in-between",
      "The Buzz",
      "Find out more",
      "Go global with Travel Mode",
      "Date",
      "Events",
      "Features",
      "Compliments",
      "Throw some Compliments their way so you stand out from the crowd.",
      "Discover",
      "A personalized page that highlights your most compatible people, refreshed daily.",
      "Incognito Mode",
      "Use Incognito Mode to hide your profile from your boss, relatives, or exes.",
      "Instant Match",
      "Started the conversation at a Bumble IRL event? Keep it going on the app.",
      "Snooze mode",
      "Put dating on hold with Snooze Mode. When you’re ready to date again, you know where we are.",
      "SuperSwipe",
      "Profile passed the vibe check? Let them know with a SuperSwipe.",
      "Travel mode",
      "Find your duty-free snack and match anywhere in the world with Travel Mode.",
      "Video chat",
      "Use video chat and audio calls to see if you’re ready to meet in person.",
      "Get the Bumble app",
      "BFF",
      "Safety",
      "Stories",
      "Support",
      "The Shop",
      "Main",
      "Throw some Compliments their way so you stand out.",
      "Compliments",
      "Features designed to create space for real, respectful, and meaningful connections.",
      "Hide your profile from your boss, relatives, or exes.",
      "Incognito Mode",
      "Put dating on hold with Snooze Mode.",
      "Snooze mode",
      "Seen someone you like? Let them know.",
      "SuperSwipe",
      "Explore Date",
      "Find your duty-free snack and match anywhere.",
      "Travel mode",
      "Get as close to IRL without leaving your house.",
      "Video Calls",
      "Get the Bumble experience straight from your browser.",
      "Web app",
      "Our leaders help bring Bumble’s values into their communities across the country.",
      "Community Leaders",
      "Features designed to help you find your people and connect over what you're into.",
      "Organize a group meetup, or discover local events happening nearby.",
      "Plans",
      "Explore BFF",
      "All the guidance and inspiration you need to help you find love and friendship.",
      "Advice and stories to help you build the friendships you want.",
      "The Friendship Hub",
      "From Tokyo to Toronto, explore the love found on Bumble around the world.",
      "Love Stories",
      "Plan the perfect date—no matter when, where or who you're dating.",
      "Seasonal Dating Guides",
      "Explore Stories",
      "Skip to main content",
      "Bumble logo",
      "Close navigation menu",
      "Open navigation menu",
      "Portrait of Whitney Wolfe Herd, founder and CEO of Bumble",
      "Whitney Wolfe Herd founded Bumble with one goal: to build the most trusted space to find love, where women make the first move, and connection is rooted in respect.{{__EOL__}}{{__EOL__}}As CEO, she still leads with the same belief: that finding love online should feel intentional, safe, and authentic. Bumble is about more than dating. It’s about helping people find what matters, with care, intention, and heart. That means using technology and AI to deepen human connection, not replace it. We’re using everything we’ve learned: the good, the imperfect and the honest, so that our entire community continues to feel welcome on Bumble.",
      "Whitney Wolfe Herd",
      "Smiling couple leaning toward a kiss and holding hands in the backseat of a car, with greenery outside.",
      "We believe love—in all its forms—is the foundation to a happy, healthy life.",
      "Hello. We’re The Love Company.",
      "Bumble match screen with two profiles and a prompt to start the conversation.",
      "The result? A member-first platform built to create kind, healthy connections.",
      "In {{date}}, we rewrote the dating rules.",
      "Our mission is to bring people closer to love.",
      "Our Mission",
      "We flipped dating norms and gave women the first move.",
      "Bumble is born",
      "{{bff}} launched to help people find their people. Because love is platonic, too.",
      "Beyond dating",
      "Serena Williams helped us bring women making the first move to the Super Bowl.",
      "Super Bowl debut",
      "We launched new functions to navigate dating during the Covid-19 pandemic.",
      "Dates went virtual",
      "We went public—led by the youngest woman to ever do it.",
      "History is made",
      "Alongside our anti-cyberflashing tech, we expanded our policies to protect women.",
      "Better safety",
      "We made the spotlight on women’s sports as bright as it should be.",
      "WNBA x Bumble",
      "Now, we’re building a future where love feels possible for everyone.",
      "Leading with love",
      "We started with one bold move. Today, we’re building the most trusted and effective place to find love.",
      "Scroll to explore",
      "Scroll left",
      "Scroll right",
      "Our Story",
      "See our open roles",
      "Help us build the most trusted place to find love.",
      "Work with us",
      "BFF app screens highlighting user profile view and interest badges for connecting with friends",
      "Whether you’ve moved to a new city or just want to expand your circle, {{bff}} makes it easy to meet like-minded people who match your vibe.",
      "Find your people",
      "Collage of Bumble profiles showing diverse people with ID verified badges, including a woman taking a mirror selfie in the center.",
      "Whether you're new to dating or ready to try again, Bumble Date is built to bring you closer to love safely and meaningfully.",
      "Find your person",
      "Smiling woman carrying a skateboard in a park",
      "Outdoors",
      "Man jogging and smiling in a city park",
      "Running",
      "Woman holding a small fluffy dog outdoors",
      "Dog parent",
      "Download Bumble",
      "We want our members to find meaningful and authentic relationships that ignite confidence and joy.",
      "We exist to bring people closer to love.",
      "Woman with long dark ponytail, black top, and sunglasses on head, smiling with the sea behind her.",
      "Bearded man in patterned shirt holding a camera, standing outdoors with trees and buildings in the background.",
      "Woman in red rainbow-striped jacket and silver headphones, wearing a green star necklace, looking at the camera.",
      "Smiling couple embracing in a black and white portrait",
      "{{name1}} & {{name2}}, married in {{num}}",
      "Find out more",
      "Read more stories",
      "\"{{__EOL__}}We are both naturally positive, happy-go-getters, but when you put us together, it feels like there is nothing we can’t accomplish.",
      "Two people laughing on a tennis court; one holds tennis balls over their eyes",
      "Meet in person",
      "Bumble IRL events mean you can stop typing and start talking. Come solo or bring a friend—and leave with a new connection.",
      "Start the chat in person",
      "People enjoying connections on Bumble through photos, video chats, and expert advice.",
      "Sign up",
      "Help shape the future of Bumble by joining our Member Circle. This select community of Members shares ideas directly with our team through chats, discussions, and product tests.{{__EOL__}}{{__EOL__}}Participants get early access to new features, sneak peeks at upcoming campaigns, and the chance to help make Bumble even better for everyone.",
      "Share your ideas",
      "Want to get to know them? Use video chat on Bumble",
      "Simply tap the video icon in your chat to start a video call, all without sharing any personal contact information.",
      "How does video chat on Bumble work?",
      "No. All calls and chats on Bumble keep your personal info safe and secure. They won’t get your number or any other contact details until you tell them.",
      "Will my match see my phone number?",
      "Absolutely! If you're not quite ready for a face-to-face, voice calls lets you connect through audio. Just select the call icon instead.",
      "Can I just try an audio call?",
      "We love a good *message received* notification. But we know it’s hard to tell whether or not your chats are going to be as good in person. That’s where video and audio calls come in.",
      "Video Chat on Bumble",
      "<a href={{video_chat_url}}>Video chats and audio calls</a> can help you get to know each other and decide if you want to take things off the app. The best part? When you make a call via Bumble, you don’t have to exchange phone numbers—so your personal information stays safe until you’re ready to share.",
      "Check your chemistry with video chat",
      "Bridge the gap between online and offline dating, and decide if it's time to take the leap and meet up.",
      "Get to know them better (and faster). A face-to-face convo or chat on the phone can reveal a lot about someone.",
      "You’re in control. We’ll keep your contact details private, so you can choose when to share them.",
      "See if you’re ready to meet in person",
      "Try a quick vibe check",
      "Connect without giving out personal info",
      "Why you should use video chats and calls",
      "Ready to start a conversation? You can choose whether to start an audio call or a video call right from your chat in the Bumble app. To start a video call, tap the gray video camera icon in the top right corner. You’ll also see three dots next to the icon, click on this and you’ll see the option to audio call as well.",
      "How to video chat",
      "Ready to try Compliments?",
      "When you send a Compliment, the person receiving it will see it when you pop up in their queue.",
      "What happens when you Compliment someone on Bumble?",
      "If their Compliment caught your eye, then go ahead and match with them. You’ll see the Compliment in your chat, and the usual <a href={{make_the_first_move_url}}>Make The First Move</a> rules apply.",
      "How do I respond to a Compliment?",
      "You can send {{num}} [[Compliments:num]] for free. When you’re all out, you can buy more in the Bumble app in packs of up to 30. One of these will be used to send that Compliment (save the rest for when you see another profile you like). Don’t worry, they won’t expire!",
      "How many Compliments can I send?",
      "A kind word (or two) can go a long way. If you want to send a Compliment but find your thumbs hovering over the keyboard, try these for inspiration:",
      "See more examples",
      "“Anyone who appreciates [artist name], has good taste.”",
      "“Your smile’s contagious!”",
      "“Your bio made me laugh. Well played.”",
      "How to send better compliments on Bumble",
      "Want to make their day? Sounds like you’re ready to use Compliments.",
      "Compliments on Bumble",
      "Use Compliments on Bumble to let a potential match know you like their profile (and maybe even make them blush). You get Compliments as part of your {{service_level_lexeme_name}} membership. It’s also a way to send and receive messages before you’ve even matched.",
      "How the Compliments feature works",
      "When you get a Compliment, it will appear on the sender’s profile. You’ll also get a notification telling you that someone likes part of your profile.",
      "See your compliments",
      "You can send a Compliment by tapping on the yellow heart icon at the bottom of someone’s profile. Where you tap is important, because you’ll be complimenting that specific photo or part of their profile! When you click, a text box will open for you to write your message (it can be up to 150 characters).",
      "Send a compliment",
      "DOWNLOAD Bumble TO TRY DISCOVER NOW",
      "Every day from 9 a.m., you’ll see new people for you in Discover. You can connect with them over the things you have in common.",
      "When does Discover update?",
      "Your Discover page sorts potential matches into 3 main categories: similar interests, same dating goals, and communities in common. Profile recommendations are also shown, based on previous matches.",
      "How is my Discover page curated?",
      "A personalized page that highlights your most compatible people, refreshed daily",
      "FIND PEOPLE WHO MATCH YOUR VIBE WITH {{qr_code}} DISCOVER",
      "Discover shows you a selection of people we think you'll like, based on your similar interests, dating goals, and communities.",
      "Try Discover",
      "LOOKING FOR A FRESH WAY TO FIND COMMON GROUND?",
      "The Discover page is updated every day, to show you even more people you’d be compatible with—so you can spend less time searching for a match, and more time getting deep with people you know you’ll vibe with.",
      "RECOMMENDATIONS REFRESHED DAILY",
      "Discover’s recommendations are based on your profile and who you’ve matched with before, so you’ll see people who like what you like and want what you want—whether that’s vegan lobster rolls or a long-term relationship.",
      "PERSONALIZED{{__EOL__}}AROUND YOU",
      "Download Bumble",
      "Frequently Asked Questions",
      "Ready to browse Bumble privately?",
      "When you activate Incognito Mode, you won’t appear to other Bumble members unless you like their profile.",
      "How does Incognito Mode work?",
      "Without Incognito Mode, your profile is visible to other daters on Bumble when you fit their preferences, like age and location. When you activate Incognito Mode, you’ll only be seen by people once you’ve liked them.",
      "Who can see me on Bumble’s Incognito Mode?",
      "Using Incognito Mode is not the same as <a href={{blocking_on_bumble_url}}>blocking someone on Bumble</a>. With this feature, if you like someone (or if you’ve messaged them in the past), they’ll be able to see your profile.",
      "Is Incognito Mode like blocking someone?",
      "Control who sees your profile with Bumble ’s Incognito Mode.",
      "Incognito mode on Bumble",
      "If you want to take a step back from dating, or browse Bumble without other daters seeing your profile, you can switch to Incognito Mode. Turning on this feature means we’ll hide you from everyone—unless you like them first. It allows you to control what you share, and who sees you.",
      "Hide your profile with Incognito mode",
      "You decide who can see your photos and personal info.",
      "Want to include something personal on your profile? You can discreetly share what you want with your current matches.",
      "Browse freely without worrying about running into an ex, your work colleague, or anyone else who's not on your dating radar.",
      "Take complete control",
      "Choose what you share",
      "Avoid awkward encounters",
      "Why you’ll love Incognito mode",
      "Incognito Mode is available for {{service_level_lexeme_name}} and {{service_level_lexeme_name_two}} members. Once you’ve signed up, you can switch it on by going to your profile tab, tapping Settings in the top right corner, and switching to Incognito Mode.",
      "Upgrade to {{service_level_lexeme_name}}",
      "How to use Incognito mode on Bumble",
      "DOWNLOAD Bumble TO TRY INSTANT MATCH TODAY",
      "In the Bumble app, head to the Profile icon at the bottom of your screen. From there, you’ll find the QR code icon at the top right of the screen. Tap on that to access it.",
      "Where can I find my personal QR code?",
      "Nope! You'll need to be connected to the internet, either via mobile data or Wi-Fi, and use the current, live QR code for Instant Match to work.",
      "Can I screenshot my QR code to share?",
      "Nope! If one person scans the code, you’ll be matched automatically.",
      "Do both people need to scan the QR code?",
      "With Instant Match, you can automatically see what you and your new match have in common—giving you a glimpse of your compatibility right from the start.",
      "FIND COMMON GROUND, FASTER",
      "Started the conversation at a Bumble IRL event? Keep it going on the app.",
      "TURN YOUR MEET-CUTE INTO AN {{qr_code}} INSTANT MATCH",
      "Instant Match makes it easy to take your meet-cute to a “let’s keep talking” level without swapping numbers or social profiles. Just have them scan your QR code to match on Bumble.",
      "Try Instant Match",
      "MET SOMEONE AT A Bumble IRL EVENT?",
      "Instead of swapping social profiles or phone numbers, Instant Match allows you to check the vibe in the app first. That way, you can get to know each other better on your own terms, thanks to Bumble's suite of safety features.",
      "A SAFER WAY TO CONNECT",
      "After meeting at a Bumble IRL event, build on the chemistry by continuing the conversation In the app and connecting over shared interests—whether that’s a love for the perfect pour-over or propagating rare succulents.",
      "KEEP THE CONVERSATION GOING",
      "Want to take a break? Try Snooze Mode",
      "Yes, you can visit your settings or your queue and switch Snooze off whenever you like.",
      "Can I deactivate Snooze Mode early?",
      "Go to settings, tap Snooze, and choose how long you want to be away. Come back whenever you feel ready.",
      "How do I use Snooze Mode on my profile?",
      "Nope—while in Snooze Mode, all swipe-and-chat activity is paused. When you go to see new people, you’ll see a message telling you how long Snooze Mode will run for, with the option to deactivate it.",
      "Can I still explore profiles and chat in Snooze Mode?",
      "People you've already messaged will see your ‘Away’ status (if you choose to set one). Otherwise, they’ll see your previous messages in their Inbox as normal.",
      "What will current matches see when I’m on Snooze Mode?",
      "You have total control over your Bumble activity, and can step away from the platform whenever you want.",
      "You can keep existing connections up to date using your status update, so it doesn’t look like you’ve <a href={{ghosted_article_url}}>ghosted</a>. Plus, it’s all automated—so you don’t need to send any messages.",
      "Take a break from actively dating without losing your connections or chats.",
      "Date (or disconnect) on your own terms",
      "Keep your connections updated",
      "Pause your activity, but not your connections",
      "Why we love Snooze mode",
      "Open the Bumble app, visit your profile tab, and tap the settings cog in the top right corner. In your Settings, tap Snooze and choose how long you'll be away for. You can hide your profile for 24 hours, 72 hours, a week, or indefinitely.{{__EOL__}}{{__EOL__}}Remember, matches without active chats will expire while you're in Snooze Mode. If you decide to set a status, people you’re currently chatting with will be able to see that you’re away.",
      "How Snooze mode works on Bumble",
      "When life gets busy, Snooze Mode is here to help. Pause your Bumble account, and date on your own terms.",
      "Snooze mode on Bumble",
      "Snooze Mode is an easy way to pause your account when you want to take a breather from dating. You can still chat with your existing connections, it just hides your profile from other people until you’re ready to get out there again. You won’t lose your profile information or delete existing connections by activating Snooze Mode.",
      "Snooze your Bumble profile",
      "While you're in Snooze Mode, you can choose to let existing connections know you're taking a breather with a status update. Pick from 'I'm traveling', 'I’m focused on work', 'I’m on a digital detox', or 'I’m prioritizing myself'. Whatever your vibe, we’ve got you.",
      "Add an ‘Away’ status",
      "Activating Snooze Mode pauses your Bumble (or {{page_partner_name_bff}}) account. Your matches won’t know you’re on Snooze Mode unless you tell them. If you decide to wake up from your Snooze Mode sooner than the timeframe you initially chose, just return to Settings and tap “deactivate Snooze Mode.” It’s as easy as that.",
      "Pause your chats",
      "Try SuperSwipe on Bumble",
      "As many as you like! {{service_level_lexeme_name}} users get {{num}} [[superswipe:num]] every week, but you can top up your balance at any time. Free members can buy packs of SuperSwipes.",
      "How many SuperSwipes can I send on Bumble?",
      "After someone uses a SuperSwipe on your profile, you’ll get notified right away. You’ll also see a label above that person’s name on their profile, letting you know they like you.",
      "How do I know if I get a SuperSwipe from someone?",
      "Feeling serious about someone? There's a cool way to break the ice. Just send a SuperSwipe to let them know you're into them and get to the good chats, faster.",
      "SuperSwipe on Bumble",
      "Standing out from the crowd isn’t always easy, but SuperSwipe can help you make a great first impression.{{__EOL__}}{{__EOL__}}When you use a SuperSwipe, a notification will be sent to the person you’ve liked. You’ll then skip to the front of their line with a label on your profile. If they like you back, it’s time to start chatting.",
      "What’s a SuperSwipe?",
      "Be bold and stand out",
      "Start more chats",
      "Make more connections",
      "SuperSwipe can help you…",
      "If you’ve got <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> or Bumble {{service_level_lexeme_name_one}}, you get {{num}} free [[superswipe:num]] per week. Plus, all members can buy packs of up to {{num_two}} [[superswipe:num_two]] from the profile tab. If you have {{service_level_lexeme_name_three}}, you’ll get {{num_three}} [[superswipe:num_three]] per week{{__EOL__}}{{__EOL__}}Using SuperSwipe is simple—when you see someone you like, just tap the yellow star icon at the bottom of their profile.",
      "How to use SuperSwipe",
      "Date on the go with Bumble’s Travel Mode",
      "<a href={{bumble_premium_url}}>{{service_level_lexeme_name}} members</a> can use Travel Mode. Switch it on and your queue will show you new faces in your chosen city.",
      "How do I use Travel Mode?",
      "Pretty much—we have a few safety restrictions that can change over time, but Travel Mode is available for most destinations.",
      "Can I use Travel Mode anywhere?",
      "Travel Mode will show your location as the center of your chosen city, so new connections in the area can find you. They’ll see a note on your profile that you’re in Travel Mode, so they know you’re visiting, or planning to visit.",
      "Packing your bags for a holiday or heading to a new city for work? Switch on Bumble’s Travel Mode to take dating on the road with you.",
      "Travel Mode on Bumble",
      "Travel Mode is your ultimate tool for making connections while you’re away. Set your location to anywhere in the world, and your profile will show up as being in the city you choose. It means you can tap into the dating scene wherever your adventures take you.",
      "What’s Travel Mode?",
      "No one knows a place better than the locals. Travel Mode can help you connect with the people who’ll make your trip extra special.",
      "Set your location to the city up to seven days before you go, so you can plan dates and meet matches ahead of time.",
      "Think beyond just beach trips—you might be home for the holidays, traveling for work, or exploring a new city. Find romance wherever you land.",
      "Find the best local date spots",
      "Have an adventure",
      "Make lasting connections",
      "Reasons to love Travel Mode",
      "Travel Mode is available to <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} and {{service_level_lexeme_name_two}} </a> members on Bumble. Tap on the Settings cog in the top right of your profile and scroll until you see Travel Mode. Choose your new location to start seeing people in that area. Your profile will let potential dates know you’re in Travel Mode.",
      "How does Travel Mode work?",
      "Try it now",
      "Here, kindness is sexy, you being you is perfect, and women come first. Always.",
      "The Home Of Make The First Move™",
      "Healthy relationships are central to living a positive, productive life. Bumble is designed to help you feel empowered while you make those connections, whether you’re dating, looking for friends, or growing your professional network.",
      "Why Bumble Matters",
      "We champion integrity, kindness, equality, confidence, and respect during all stages of any relationship. We don’t just welcome, we celebrate every orientation—whether you’re here to find love or simply find fun.",
      "What Bumble Values",
      "On Bumble, women set the tone by making the first move or by setting an Opening Move for matches to reply to. Shifting old-fashioned power dynamics and encouraging equality from the start.",
      "How Bumble Works",
      "About Us",
      "Download now",
      "It’s better on the app.",
      "Features designed to make online dating actually, you know, enjoyable",
      "February 12, 2024",
      "How to increase your emotional intimacy in your relationship",
      "Jan 25, 2024",
      "How to use Bumble when you have never used a dating app before",
      "February 5, 2024",
      "Deception Detector™",
      "All the dating news that’s fit to print",
      "Put dating on hold with <b>Snooze Mode</b>. When you’re ready to date again, you know where we are.",
      "Take a break",
      "Use <b>video calls</b> and <b>audio chats</b> to get as close to IRL without leaving your house.",
      "Sound it out",
      "View more",
      "Choose <b>Opening Moves</b> to invite your match to start the chat, so you don’t have to.",
      "Do less, date more",
      "Find your duty-free snack and match anywhere in the world with <b>Travel Mode</b>.",
      "Take us away",
      "Profile passed the vibe check? Let them know with a <b>SuperSwipe</b>.",
      "Get their attention",
      "Throw some <b>Compliments</b> their way so you stand out from the crowd.",
      "Make them blush",
      "Use <b>Incognito Mode</b> to hide your profile from your boss, relatives, or exes.",
      "Go undercover",
      "Date the way you want to",
      "A Few Months Later, She Met One of Her Bridesmaids There, Too",
      "Hannah Met Her Now-Husband on Bumble.",
      "Before building their tiny house together Carène and You-Liang met on Bumble, where You-Liang was drawn in by Carène’s travel pics.",
      "Carène and You-Liang",
      "Brian and Kaci Were Stationed Overseas Together—But They Met on Bumble",
      "Brian and Kaci",
      "If it worked for them, it could work for you",
      "Make the next move",
      "See what’s new",
      "You deserve better, so we’ve designed great ways for you to date more and stress less.",
      "Bring your bar back up to where it belongs",
      "About Bumble",
      "We’re the only app that makes dating better by putting women’s experiences first. Because when things are better for women, they’re better for everyone.",
      "Make the first move™",
      "Find someone you actually want to date, then go ahead and Make the First Move. Make genuine connections, vibe over what you both love, and most importantly, have fun.",
      "Meet someone with Bumble Date",
      "Find friends with work benefits. Connect with other business professionals to find your next job, a mentor or even a whole new career.",
      "Make career moves with Bumble Bizz",
      "Meet someone like you. Or unlike you. Make new friends and find new things to do together—whether you’re home or away.",
      "Find new friends on Bumble For Friends",
      "We’re not just for dating",
      "Bumble is the dating app where women Make the First Move. It’s the app that changed the way people date, create meaningful relationships, and network. Download now.",
      "Bumble on {{social_network}}",
      "Learn more",
      "Download Bumble from the App Store or Google Play and sign in with the same account you used on Bumble web.{{__EOL__}}{{__EOL__}}Scan the QR code below with your phone or tablet to get started.{{__EOL__}}{{__EOL__}}Your matches and conversations are waiting for you on the app. 💛",
      "Get the app",
      "So we can keep bringing you the best experience and safety features, Bumble is now app-only.",
      "Bumble is now app-only.",
      "Never miss a connection",
      "Call without sharing your number",
      "Trust your matches are genuine",
      "Get real-time notifications so you don’t miss a message.",
      "Use our in-app voice and video calls to help move from match to IRL, safely.",
      "Chat confidently with verified members using easy in-app photo and ID verification.",
      "Why switch to the Bumble app?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "We’re sorry, but we can’t find the page you were looking for.",
      "Contact us",
      "Oops, something went wrong",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Premium",
      "Bumble - The Blog",
      "Careers",
      "Chat",
      "Cities",
      "Manage cookies",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "Dating Confidence Report",
      "Apple and the Apple logo are trademarks of Apple Inc.{{__EOL__}}Google Play is a trademark of Google LLC.",
      "Download",
      "Facebook",
      "Follow us",
      "Help Center",
      "Instagram",
      "Language",
      "LinkedIn",
      "Bumble is part of Bumble Inc.",
      "Privacy policy",
      "Safety Center",
      "Sitemap",
      "Modern Slavery Act statement",
      "Terms and conditions",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "Compliments"
            ],
            "singular": [
                  "Compliment"
            ]
      },
      "day": {
            "plural": [
                  "days"
            ],
            "singular": [
                  "day"
            ]
      },
      "hour": {
            "plural": [
                  "hours"
            ],
            "singular": [
                  "hour"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "months"
            ],
            "singular": [
                  "month"
            ]
      },
      "second": {
            "plural": [
                  "seconds"
            ],
            "singular": [
                  "second"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "years"
            ],
            "singular": [
                  "year"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
